module.exports = __webpack_public_path__ + "img/syria.f9bba38d.svg";